
<template>
  <div>
    <div>
      <!-- <bill-profile v-if="oneBill && oneBill.data" is_details></bill-profile> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import billProfile from '@/_backoffice/_financial/components/bill/shared/BillProfile.vue'

export default {
  name: 'BillDetail',
  components: { billProfile },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapMutations({
      setOneBill: 'Financial/getOneFinancial'
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      oneBill: state => state.Financial.oneBill,
    })
  },
  mounted () {
    this.setOneBill({item: this.item, kind: 'bills'});
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>